import { render, staticRenderFns } from "./ApplicantMerchantContract.vue?vue&type=template&id=4943feb6&scoped=true"
import script from "./ApplicantMerchantContract.vue?vue&type=script&lang=js"
export * from "./ApplicantMerchantContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4943feb6",
  null
  
)

export default component.exports